import React, { useEffect } from 'react'
import { useStateValue } from '../providers/StateProvider'
import styled, { keyframes } from 'styled-components'

//This alert shows an extremely secure login screen. Good luck trying to hack it :)

const disappear = keyframes`
  from {
    opacity: 1;
    visibility: visible;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
`

const appear = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const scan = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const scan2 = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(150px);
  }
`

const approved = keyframes`
  from {
    background-color: rgba(246, 240, 220, .2);
  }
  to {
    background-color: rgba(246, 240, 220, .75);
  }
`

const Container = styled.div`
  background-color: #0E0E11;
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  animation: ${disappear} .5s 10s forwards linear;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  color: #aaa;
  z-index: 1;
`

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h2 {
    font-size: 2em;
  }

  p {
    font-size: 1.5em;
    line-height: 1.5;
    opacity: 0;
    animation: ${appear} .75s 7s forwards linear;
  }

  span {
    color: #D10A0A;
  }
`

const Scan = styled.div`
  background-color: rgba(246, 240, 220, .2);
  animation: ${approved} 0.75s 5.75s forwards linear;
  border: 2px solid #F6F0DC;
  border-radius: 100%;
  width: 150px;
  height: 150px;
  margin: 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

const Inner = styled.div`
  border: 2px solid rgba(246, 240, 220, .6);
  border-radius: 100%;
  width: 85px;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    background-color: #D10A0A;
    border-radius: 100%;
    width: 20px;
    height: 20px;
    z-index: 1;
    animation: ${disappear} 0.75s 5.75s forwards linear;
  }
`

const ScanLine = styled.div`
  width: 71px;
  height: 2px;
  background-color: #F6F0DC;
  position: absolute;
  top: 74px;
  right: 4px;
  animation: ${scan} 2.5s .5s 2 linear;
  transform-origin: left center;
`

const ScanLine2 = styled.div`
  width: 190px;
  height: 2px;
  background-color: rgba(246, 240, 220, .6);
  position: absolute;
  top: 0;
  left: -20px;
  z-index: 2;
  animation: ${scan2} 5s .5s linear forwards;
`

const LoginAlert = () => {
  const { changeLoginAlert, seenLoginAlert } = useStateValue()

  useEffect(() => {
    changeLoginAlert(seenLoginAlert + 1)
  }, [])

  return (
    <Container>
      <Main>
        <h2>Confirming Identity</h2>
        <Scan>
          <ScanLine2></ScanLine2>
          <ScanLine></ScanLine>
          <Inner>
            <div></div>
          </Inner>
        </Scan>
        <p>Identity confirmed. Welcome, <span>Fury, Nicholas J.</span></p>
      </Main>
    </Container>
  )
}

export default LoginAlert
